import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'NormalTextNode',
  props: {
    text: {
      type: String as PropType<string>,
      default: '',
    },
    innerText: {
      type: String as PropType<string>,
      default: '',
    },
    displayText: {
      type: String as PropType<string>,
      default: '',
    },
  },
});
